export interface IFilterOption {
  Id: string;
  Title: string;
}

export type TFilterCategory = IFilterOption;

export type TSortParameter = IFilterOption;

export type TSuggestedSearchItem = {
  Name: string;
  Value: string;
};

export type TFiltersData = {
  ClearFilterText: string;
  DateFilterText: string;
  FilterTagsText: string;
  FilteringCategories: TFilterCategory[];
  SearchPlaceholder: string;
  SortByText: string;
  SortParameters: TSortParameter[];
  HideFilterText: string;
  ShowFiltersText: string;
  // Below texts were added only to EG Blog
  NoOptionsMessage?: string;
  DateRange?: {
    Heading: string;
    Close: string;
    Title: string;
    FromLabel: string;
    FromPlaceholder: string;
    ToLabel: string;
    ToPlaceholder: string;
    ShowResults: string;
    ClearFilters: string;
  },
  Articles?: string;
  PaginationStartText?: string;
  PaginationEndText?: string;
  BlogItemCtaText?: string;
};

export enum BlogTypes {
  Blog = "Blog",
  News = "News",
  Event = "Event",
}

export type TBlog = {
  Date: string;
  Description: string;
  FeaturedText: string;
  Id: string;
  ImageUrl: string;
  ReadTime: string;
  Tags: string[];
  Title: string;
  Type: BlogTypes;
  Url: string;
};

export type TBlogsData = {
  BlogList: TBlog[];
  LinkText: string;
  NoResultsText: string;
  TotalCount: number;
};
